<template>
    <section v-if="isshow" class="our_works" v-animate="'fade-in'">
        <div class="top">
            <div class="container d-flex flex-column h-100">
                <h2 class="text-center sub_title">Our Works</h2>
                <div class="row text-white work-area-group">
                    <div v-for="work in works" :key="work.id" :class="`col-md-6 work-area work-${work.id}`">
                        <div class="work-container">
                            <a class="link-full" :href="work.link+'?id='+work.id"></a>
                            <div class="work-image"
                                 :style="{ backgroundImage: `url(${work.logo})` }"></div>
                            <div class="middle w-100 text-center d-flex align-items-center">
                                <div class="w-100">
                                    <h5 class="work-title">{{work.title}}</h5>
                                    <p>{{work.subtitle}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <a class="btn mt-5 button btn-dark-border hover_bg_label" href="/global/works/">
                        <span class="hover_bg_label_text">View all</span>
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'OurWork',
        props: {
            country: String
        },
        data() {
            return {
                isshow: true,
                works: [],
            }
        },
        created() {
            this.axios.get('/global-works/works.json').then( res => {
                for(let i=0; i<res.data.length; i++) {
                    if(res.data[i].country == this.country && this.works.length<2) {
                        this.works.push(res.data[i])
                    }
                }
                if(this.works.length == 0) {this.isshow = false}
            })
        }
    }
</script>

<style lang="scss" scoped>
    .our_works {
        h2 {
            font-size: 48px;
            letter-spacing: 1.92px;
            line-height: 56px;
            margin-bottom: 13px;
            font-family: 'Montserrat', sans-serif;
        }

        .top {
            background: #EBEBEB;
            padding: 100px 0;
        }

        .bottom {
            background: #DDDDDD;
            height: 49%;
            position: relative;
            transition: background-color .3s ease-in-out;
            &:hover {
                background: #FFBC07;
                .btn-with-arrow {
                    background: #FFBC07;
                    span {
                        color: #000;

                        &:after {
                            background: url(../../assets/icons/arrow-right-dark.svg) no-repeat right center;
                            transform: translateX(10px);
                        }
                    }
                }
            }
        }

        .work-area-group {
            margin-top: auto;
            transform: translateY(40px);
            z-index: 12;
            margin-bottom: 52px;
        }
    }

    .work-container {
        height: 338px;
        position: relative;
        overflow: hidden;

        .middle {
            opacity: 1;
        }

        .work-image {
            height: 100%;
            width: 100%;
            background-color: #666666;
            background-blend-mode: multiply;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            -webkit-transition: all .3s;
            -moz-transition: all .3s;
            -o-transition: all .3s;
            transition: all .3s;
        }

        &:hover {
            .work-image {
                transform: scale(1.1);
            }
        }
    }

    .work-title {
        font-size: 28px;
        letter-spacing: 1.12px;
        line-height: 40px;
    }

    .work-detail {
        font-size: 20px;
        letter-spacing: 0.8px;
        line-height: 30px;
    }

    .btn-with-arrow {
        background: #000;
        width: 387px;
        height: 90px;
        border-radius: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
            color: #fff;
            font-size: 28px;
            letter-spacing: 1.4px;
            line-height: 40px;
            font-weight: bold;
            display: block;

            &:after {
                content: "";
                display: inline-block;
                width: 71px;
                height: 13px;
                background: url(../../assets/icons/arrow-right.svg) no-repeat right center;
                margin-left: 1rem;
            }
        }
    }

    @media screen and (max-width: 991px) {
        .our_works {
            height: auto;
            max-height: none;
            .work-area-group {
                transform: none;
                margin-top: 60px;
                .work-area {
                    margin-bottom: 25px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
            .bottom {
                height: 250px;
            }
        }
    }

    @media screen and (max-width: 768px) {
        .btn-with-arrow {
            width: auto;
            padding: 1rem 3rem;
        }
    }

    @media screen and (max-width: 767px) {
        .our_works {
            .work-area-group {
                margin-bottom: 0;
            }
        }
    }

    @media screen and (max-width: 400px) {
        .btn-with-arrow {
            padding: .5rem 1rem;
        }
    }
</style>
